import React, { useState } from 'react';
import { X, Building2, Plus } from 'lucide-react';

const LawFirmModal = ({ isOpen, onClose, mode, onJoin, onCreate }) => {
  const [inviteCode, setInviteCode] = useState('');
  const [firmName, setFirmName] = useState('');
  const [firmDescription, setFirmDescription] = useState('');

  const handleJoin = () => {
    if (inviteCode.trim()) {
      onJoin(inviteCode);
      onClose();
    }
  };

  const handleCreate = () => {
    if (firmName.trim()) {
      onCreate({ name: firmName, description: firmDescription });
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            {mode === 'join' ? (
              <Building2 className="text-blue-600" size={24} />
            ) : (
              <Plus className="text-green-600" size={24} />
            )}
            <h2 className="text-xl font-semibold text-gray-800">
              {mode === 'join' ? 'Join Law Firm' : 'Create Law Firm'}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X size={24} />
          </button>
        </div>

        {mode === 'join' ? (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Invite Code
              </label>
              <input
                type="text"
                value={inviteCode}
                onChange={(e) => setInviteCode(e.target.value)}
                placeholder="Enter the invite code provided by the law firm"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="bg-blue-50 p-3 rounded-lg">
              <p className="text-sm text-blue-800">
                Ask your law firm administrator for the invite code to join their practice.
              </p>
            </div>
            <div className="flex gap-3">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleJoin}
                disabled={!inviteCode.trim()}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Join Firm
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Firm Name *
              </label>
              <input
                type="text"
                value={firmName}
                onChange={(e) => setFirmName(e.target.value)}
                placeholder="Enter your law firm name"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Description (Optional)
              </label>
              <textarea
                value={firmDescription}
                onChange={(e) => setFirmDescription(e.target.value)}
                placeholder="Brief description of your law firm"
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>
            <div className="bg-green-50 p-3 rounded-lg">
              <p className="text-sm text-green-800">
                After creating your firm, you'll be able to invite other lawyers using an invite code.
              </p>
            </div>
            <div className="flex gap-3">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleCreate}
                disabled={!firmName.trim()}
                className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Create Firm
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LawFirmModal;
